(function(){
  if (typeof window === 'undefined') return;

  var rules = window.__depositRules || {};
  var depositVariantIds = new Set();
  Object.keys(rules).forEach(function(k){ depositVariantIds.add(rules[k].depositVariantId); });

  if (depositVariantIds.size === 0) return;

  var reconciling = false;
  var pending = false;

  function groupKey(variantId, planId) {
    return variantId + ':' + (planId || 'none');
  }

  function cartFetch(url, body) {
    var opts = {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    };
    if (body) {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return origFetch(url, opts).then(function(r){ return r.json(); });
  }

  function reconcile() {
    return cartFetch('/cart.js').then(function(cart){
      var required = {};
      var existing = {};

      cart.items.forEach(function(item){
        var planId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
          ? item.selling_plan_allocation.selling_plan.id : null;
        var planName = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
          ? item.selling_plan_allocation.selling_plan.name : null;

        if (depositVariantIds.has(item.variant_id)) {
          var k = groupKey(item.variant_id, planId);
          if (!existing[k]) existing[k] = { variantId: item.variant_id, planId: planId, quantity: 0, lineKeys: [] };
          existing[k].quantity += item.quantity;
          existing[k].lineKeys.push(item.key);
          return;
        }

        var rule = rules[item.product_id];
        if (!rule) return;

        var depositPlanId = null;
        if (planName && rule.planMap && rule.planMap[planName] != null) {
          depositPlanId = rule.planMap[planName];
        }
        var key = groupKey(rule.depositVariantId, depositPlanId);
        if (!required[key]) required[key] = { variantId: rule.depositVariantId, planId: depositPlanId, quantity: 0 };
        required[key].quantity += item.quantity * (rule.qtyPer || 1);
      });

      var ops = [];

      Object.keys(existing).forEach(function(k){
        if (required[k]) return;
        existing[k].lineKeys.forEach(function(lineKey){
          ops.push({ type: 'change', id: lineKey, quantity: 0 });
        });
      });

      Object.keys(required).forEach(function(k){
        var req = required[k];
        if (existing[k]) {
          if (existing[k].quantity !== req.quantity) {
            ops.push({ type: 'change', id: existing[k].lineKeys[0], quantity: req.quantity });
          }
        } else {
          var body = { id: req.variantId, quantity: req.quantity };
          if (req.planId) body.selling_plan = req.planId;
          ops.push({ type: 'add', body: body });
        }
      });

      if (ops.length === 0) return false;

      return ops.reduce(function(p, op){
        return p.then(function(){
          if (op.type === 'change') {
            return cartFetch('/cart/change.js', { id: op.id, quantity: op.quantity });
          }
          return cartFetch('/cart/add.js', op.body);
        });
      }, Promise.resolve()).then(function(){ return true; });
    });
  }

  function triggerReconcile() {
    if (reconciling) { pending = true; return; }
    reconciling = true;
    (function loop(){
      pending = false;
      return reconcile().then(function(changed){
        if (pending) return loop();
        return changed;
      });
    })().then(function(changed){
      reconciling = false;
      if (changed) document.dispatchEvent(new CustomEvent('cart:build'));
    }).catch(function(e){
      reconciling = false;
      if (window.console && console.error) console.error('[deposit-reconciler]', e);
    });
  }

  var origFetch = window.fetch.bind(window);
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  window.fetch = function(input, init){
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isMutation = CART_MUTATION_RE.test(url);
    var p = origFetch.apply(this, arguments);
    if (isMutation && !reconciling) {
      p.then(function(){ queueMicrotask(triggerReconcile); }, function(){});
    }
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url){
    this.__depositCartUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(){
    var self = this;
    if (self.__depositCartUrl && CART_MUTATION_RE.test(self.__depositCartUrl) && !reconciling) {
      self.addEventListener('load', function(){ queueMicrotask(triggerReconcile); });
    }
    return origSend.apply(this, arguments);
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    triggerReconcile();
  } else {
    document.addEventListener('DOMContentLoaded', triggerReconcile, { once: true });
  }
})();
